import { useGet, usePut } from '../../../sharedModules/hooks/useQuery';
import { WarehouseNotificationConfig, warehouseNotificationConfigUrl } from '../model';

export function useWarehouseNotificationConfig(location: string) {
  return useGet<WarehouseNotificationConfig>({
    url: warehouseNotificationConfigUrl(location),
    enabled: !!location,
  });
}

export function useUpdateWarehouseNotificationConfig() {
  return usePut<WarehouseNotificationConfig>();
}
